/**
 * @generated SignedSource<<3b8b53e0c37ee5345f9243d4353415ac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type EditSubscriptionTaskInput = {
  environment: ZakekeEnvironment;
  masterSalesChannelID?: string | null;
  planID?: number | null;
  secondarySalesChannelID?: string | null;
};
export type salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation$variables = {
  input: EditSubscriptionTaskInput;
};
export type salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation$data = {
  readonly generateEditSubscriptionTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation = {
  response: salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation$data;
  variables: salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateEditSubscriptionTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b8120dcec6547d673ee3521d11c5c90e",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSwitchQueriesGenerateEditSubscriptionTaskMutation(\n  $input: EditSubscriptionTaskInput!\n) {\n  generateEditSubscriptionTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4b981732e2d3c34e1e79c02eac8549c";

export default node;
